import axios from 'axios';

const client = axios.create({
  baseURL: '/api'
});

client.interceptors.request.use(config => {
  const url = config.url || '';
  let token = null;

  if (url.startsWith('/party/') || url.startsWith('/auth/party')) {
    token = localStorage.getItem('party_token');
  } else if (url.startsWith('/candidates/public') || url.startsWith('/voter') || url.startsWith('/votes') || url.startsWith('/auth/voter')) {
    token = localStorage.getItem('voter_token');
  } else if (
    url.startsWith('/admin/') ||
    url.startsWith('/candidates') ||
    url.startsWith('/parties') ||
    url.startsWith('/election') ||
    url.startsWith('/auth/admin')
  ) {
    token = localStorage.getItem('admin_token');
  }

  if (!token) {
    token = localStorage.getItem('admin_token') ||
            localStorage.getItem('voter_token') ||
            localStorage.getItem('party_token');
  }

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default client;
